import axiosClient from "./axiosClient";
import { IClientRegisterEvent, IQrEvent } from "@interfaces";

export const eventActivityAPI = {
    clientRegisterevent: (values: IClientRegisterEvent) => {
        const url = "event-activity/join-event-activity";
        return axiosClient.post(url, values);
    },
    getEvent: (params: string) => {
        const url = "event-activity/";
        return axiosClient.get(url + params);
    },
    getEventList: () => {
        const url = "event-activity";
        return axiosClient.get(url);
    },
    getEventOwn: (params: string) => {
        const url = "event-activity/user-event-activity/";
        return axiosClient.get(url + params);
    },
    getEventRank: (params: string) => {
        const url = "event-activity/user-rank-event-activity/";
        return axiosClient.get(url + params);
    },
    scanQrEvent: (values: IQrEvent) => {
        const url = "event-activity/update-qr-user";
        return axiosClient.post(url, values);
    },
};
